import type { MeetingParticipant } from "../../models/meeting.model"

export interface InviteesCardMeeting {
  host: string
  hostEmail?: string
  invitees?: string[]
  passiveInvitees?: string[]
  participants?: MeetingParticipant[]
}

export interface InviteeRow {
  key: string
  name: string
  email?: string
  kind: "organizer" | "invitee" | "viewOnly"
}

/**
 * Everyone on the meeting, organizer first: active invitees, then view-only
 * ones. Named from the meeting's own `participants` (the server names every
 * invitee it knows); an address nobody named is shown as itself. The organizer
 * is the host's own row, so their address is not listed a second time.
 */
export function inviteeRows(m: InviteesCardMeeting): InviteeRow[] {
  const hostEmail = m.hostEmail?.toLowerCase()
  const nameOf = new Map<string, string>()
  for (const p of m.participants ?? []) {
    if (p.email) nameOf.set(p.email.toLowerCase(), p.name)
  }
  const rows: InviteeRow[] = [{ key: "organizer", name: m.host, email: m.hostEmail, kind: "organizer" }]
  const seen = new Set<string>(hostEmail ? [hostEmail] : [])
  const add = (email: string, kind: InviteeRow["kind"]) => {
    const k = email.toLowerCase()
    if (seen.has(k)) return
    seen.add(k)
    rows.push({ key: `${kind}:${k}`, name: nameOf.get(k) ?? email, email, kind })
  }
  for (const e of m.invitees ?? []) add(e, "invitee")
  for (const e of m.passiveInvitees ?? []) add(e, "viewOnly")
  return rows
}
